import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaInstallService } from '../../../services/pwa-install.service';

/** Aviso para instalar SmartBreak como aplicación (Android, Chrome, Edge). */
@Component({
  selector: 'app-install-app-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <aside
      *ngIf="visible && (pwa.canInstall$ | async)"
      class="fixed left-3 right-3 bottom-20 z-[9000] mx-auto max-w-md rounded-2xl border border-slate-700/60 bg-slate-900/90 backdrop-blur-md p-4 shadow-2xl text-white"
      role="note"
      aria-label="Instala SmartBreak">
      <div class="flex items-start gap-3">
        <img src="icons/icon-96x96.png" alt="" width="44" height="44" class="rounded-xl flex-none" />
        <div class="flex-1 min-w-0">
          <h3 class="text-sm font-bold leading-tight">Instala SmartBreak en tu dispositivo</h3>
          <p class="text-xs text-slate-300 mt-1 leading-relaxed">
            Ábrela como una app, sin barra del navegador, y recibe tus recordatorios de pausa a tiempo.
          </p>
          <div class="mt-3 flex flex-wrap gap-2">
            <button
              type="button"
              (click)="install()"
              class="rounded-xl bg-gradient-to-r from-emerald-500 to-[#00F0FF] px-3.5 py-2 text-xs font-bold text-slate-900">
              Instalar
            </button>
            <button
              type="button"
              (click)="later()"
              class="rounded-xl border border-slate-600 px-3.5 py-2 text-xs font-semibold text-slate-300 hover:bg-slate-800">
              Ahora no
            </button>
            <button type="button" (click)="never()" class="px-2 py-2 text-xs text-slate-400 underline">
              No volver a mostrar
            </button>
          </div>
        </div>
      </div>
    </aside>
  `
})
export class InstallAppBannerComponent {
  readonly pwa = inject(PwaInstallService);
  visible = !this.pwa.isSuppressed();

  async install(): Promise<void> {
    await this.pwa.install();
    this.visible = false;
  }

  later(): void {
    this.pwa.snooze();
    this.visible = false;
  }

  never(): void {
    this.pwa.never();
    this.visible = false;
  }
}
